import {
  IChangePasswordObj,
  IUserAuthorizationFormData,
  IUserAuthorizationResponse,
  IUserRegisterFormData,
  IUserRegisterEmailFormData
} from '../types'
import { serverApi } from '../utils/request'
import Path from '../utils/paths'

class AuthService {
  public async signIn(data: IUserAuthorizationFormData): Promise<IUserAuthorizationResponse> {
    const result = await serverApi.post<IUserAuthorizationResponse>(Path.authentication.doLoginByCredentials, {
      emailOrUsername: data.emailOrUsername,
      password: data.password
    })
    return result.data
  }

  public async signUp(data: IUserRegisterFormData): Promise<any> {
    const result = await serverApi.post<any>(Path.authentication.registerUser, data)
    return result.data
  }

  public async resendInviteEmail(data: IUserRegisterEmailFormData): Promise<any> {
    const result = await serverApi.post<any>(Path.authentication.resendInviteEmail, data)
    return result.data
  }

  public async recoverPassword(email: string): Promise<boolean> {
    const recoverPasswordResponse = await serverApi.post<boolean>(Path.authentication.doSendPasswordRecoveryEmail, {
      email
    })
    return recoverPasswordResponse.data
  }

  public async changePassword(changePasswordObj: IChangePasswordObj): Promise<any> {
    return await serverApi.patch(Path.user.changePasswordByRecoveryToken, changePasswordObj)
  }

  public async checkToken(token: string): Promise<void> {
    const checkTokenResponse = await serverApi.get<void>(Path.authentication.checkPasswordRecoveryToken, {
      params: { token }
    })
    return checkTokenResponse.data
  }
}

const authService = new AuthService()

export { authService }



// WEBPACK FOOTER //
// ./src/services/Auth.ts